import { render, staticRenderFns } from "./DragDropArea.vue?vue&type=template&id=4c34c71e&"
import script from "./DragDropArea.vue?vue&type=script&lang=js&"
export * from "./DragDropArea.vue?vue&type=script&lang=js&"
import style0 from "./DragDropArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports